/* ==========================================================================
   Impulso Pro Alta Conversión · JavaScript del tema (código propio)
   Sin dependencias. Cada componente se inicia por atributo data-*.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- utilidades ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatearDinero(centavos, formato) {
    formato = formato || '${{amount_no_decimals_with_comma_separator}}';
    var valor = (Number(centavos) || 0) / 100;
    function conSeparadores(num, dec, milesSep, decSep) {
      var partes = num.toFixed(dec).split('.');
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, milesSep);
      return dec > 0 ? partes[0] + decSep + partes[1] : partes[0];
    }
    var reemplazos = {
      amount: conSeparadores(valor, 2, ',', '.'),
      amount_no_decimals: conSeparadores(valor, 0, ',', '.'),
      amount_with_comma_separator: conSeparadores(valor, 2, '.', ','),
      amount_no_decimals_with_comma_separator: conSeparadores(valor, 0, '.', ','),
      amount_with_apostrophe_separator: conSeparadores(valor, 2, "'", '.'),
      amount_no_decimals_with_space_separator: conSeparadores(valor, 0, ' ', ',')
    };
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, clave) {
      return reemplazos[clave] !== undefined ? reemplazos[clave] : m;
    });
  }

  /* ---------- carrusel genérico (pista con scroll-snap) ---------- */
  function paso(pista) {
    var h = pista.children;
    if (h.length > 1) return (h[1].offsetLeft - h[0].offsetLeft) || pista.clientWidth || 1;
    return pista.clientWidth || 1;
  }
  function indiceActual(pista) {
    return Math.round(pista.scrollLeft / paso(pista));
  }
  function irA(pista, i) {
    var hijos = pista.children;
    if (!hijos.length) return;
    i = Math.max(0, Math.min(i, hijos.length - 1));
    pista.scrollTo({ left: hijos[i].offsetLeft - hijos[0].offsetLeft, behavior: 'smooth' });
  }

  /* ---------- Galería de producto ---------- */
  function iniciarGaleria(galeria) {
    if (galeria.dataset.listo) return;
    galeria.dataset.listo = '1';
    var pista = $('[data-galeria-pista]', galeria);
    var miniaturas = $$('[data-ir-a]', galeria);
    var contador = $('[data-galeria-actual]', galeria);
    var filaMini = $('[data-galeria-miniaturas]', galeria);
    if (!pista) return;

    function marcar(i) {
      miniaturas.forEach(function (b, j) {
        if (j === i) {
          b.setAttribute('aria-current', 'true');
          if (filaMini) {
            var izq = b.offsetLeft - filaMini.offsetLeft - (filaMini.clientWidth - b.clientWidth) / 2;
            filaMini.scrollTo({ left: izq, behavior: 'smooth' });
          }
        } else {
          b.removeAttribute('aria-current');
        }
      });
      if (contador) contador.textContent = i + 1;
    }

    var temporizador;
    pista.addEventListener('scroll', function () {
      clearTimeout(temporizador);
      temporizador = setTimeout(function () { marcar(indiceActual(pista)); }, 60);
    }, { passive: true });

    miniaturas.forEach(function (b) {
      b.addEventListener('click', function () { irA(pista, Number(b.dataset.irA)); });
    });
    var ant = $('[data-galeria-anterior]', galeria);
    var sig = $('[data-galeria-siguiente]', galeria);
    var total = pista.children.length;
    if (ant) ant.addEventListener('click', function () {
      var i = indiceActual(pista); irA(pista, i === 0 ? total - 1 : i - 1);
    });
    if (sig) sig.addEventListener('click', function () {
      var i = indiceActual(pista); irA(pista, i >= total - 1 ? 0 : i + 1);
    });

    galeria.irAMedia = function (mediaId) {
      var slide = $('[data-media-id="' + mediaId + '"]', pista);
      if (slide) irA(pista, Number(slide.dataset.indice));
    };
  }

  /* ---------- Mini slider (testimonios, etc.) ---------- */
  var FLECHA_IZQ = '<svg class="ip-icono" viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var FLECHA_DER = '<svg class="ip-icono" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function iniciarMiniSlider(raiz) {
    if (raiz.dataset.listo) return;
    raiz.dataset.listo = '1';
    var pista = $('[data-pista]', raiz);
    var puntos = $('[data-puntos]', raiz);
    if (!pista) return;
    var total = pista.children.length;
    var posiciones = total;
    var botones = [];
    var auto = null;

    function ultimaPosicion() { return Math.max(0, posiciones - 1); }

    function construirPuntos() {
      var visibles = Math.max(1, Math.round(pista.clientWidth / paso(pista)));
      posiciones = Math.max(1, total - visibles + 1);
      if (!puntos) return;
      puntos.innerHTML = '';
      botones = [];
      puntos.hidden = posiciones < 2;
      if (posiciones < 2) return;
      var ant = document.createElement('button');
      ant.type = 'button'; ant.className = 'ip-puntos__flecha'; ant.setAttribute('aria-label', 'Anterior');
      ant.dataset.dir = '-1'; ant.innerHTML = FLECHA_IZQ;
      puntos.appendChild(ant);
      for (var i = 0; i < posiciones; i++) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ip-puntos__punto';
        b.setAttribute('aria-label', 'Ir al ' + (i + 1));
        b.dataset.i = i;
        puntos.appendChild(b); botones.push(b);
      }
      var sig = document.createElement('button');
      sig.type = 'button'; sig.className = 'ip-puntos__flecha'; sig.setAttribute('aria-label', 'Siguiente');
      sig.dataset.dir = '1'; sig.innerHTML = FLECHA_DER;
      puntos.appendChild(sig);
      marcar();
    }

    function marcar() {
      var i = Math.min(indiceActual(pista), ultimaPosicion());
      botones.forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }

    function avanzar(dir) {
      var actual = Math.min(indiceActual(pista), ultimaPosicion());
      var destino = actual + dir;
      if (destino > ultimaPosicion()) destino = 0;
      if (destino < 0) destino = ultimaPosicion();
      irA(pista, destino);
    }

    if (puntos) puntos.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t) return;
      if (t.dataset.dir) avanzar(Number(t.dataset.dir));
      else irA(pista, Number(t.dataset.i));
      reiniciarAuto();
    });

    function reiniciarAuto() {
      clearInterval(auto);
      if (raiz.dataset.autoplay !== 'true' || posiciones < 2) return;
      auto = setInterval(function () { if (!document.hidden) avanzar(1); }, 5000);
    }

    pista.addEventListener('scroll', function () { window.requestAnimationFrame(marcar); }, { passive: true });
    pista.addEventListener('touchstart', function () { clearInterval(auto); }, { passive: true });
    var tResize;
    window.addEventListener('resize', function () {
      clearTimeout(tResize);
      tResize = setTimeout(function () { construirPuntos(); reiniciarAuto(); }, 150);
    });
    construirPuntos();
    reiniciarAuto();
  }

  /* ---------- Producto: variantes, precio, cantidad, barra fija ---------- */
  function iniciarProducto(seccion) {
    if (seccion.dataset.listo) return;
    seccion.dataset.listo = '1';
    var jsonEl = $('[data-producto-json]', seccion);
    var datos = {};
    try { datos = JSON.parse(jsonEl ? jsonEl.textContent : '{}'); } catch (e) { datos = {}; }
    var variantes = datos.variantes || [];
    var formatoMoneda = datos.moneda;
    var inputId = $('[data-variante-id]', seccion);
    var galeria = $('[data-galeria]', seccion);

    function opcionesElegidas() {
      var elegidas = [];
      $$('[data-opcion]', seccion).forEach(function (el) {
        var i = Number(el.dataset.opcion);
        if (el.tagName === 'SELECT') elegidas[i] = el.value;
        else if (el.checked) elegidas[i] = el.value;
      });
      return elegidas;
    }

    function actualizarPrecio(v) {
      $$('[data-precio-actual]', seccion).forEach(function (el) { el.textContent = formatearDinero(v.price, formatoMoneda); });
      var antes = $('[data-precio-antes]', seccion);
      var hayOferta = v.compare_at_price && v.compare_at_price > v.price;
      if (antes) {
        antes.hidden = !hayOferta;
        if (hayOferta) antes.textContent = formatearDinero(v.compare_at_price, formatoMoneda);
      }
      var bloque = $('[data-bloque-precio]', seccion);
      var etiqueta = $('[data-etiqueta-ahorro]', seccion);
      if (bloque && etiqueta) {
        etiqueta.hidden = !hayOferta;
        if (hayOferta) {
          var ahorro = v.compare_at_price - v.price;
          var txt = bloque.dataset.formatoAhorro === 'porcentaje'
            ? Math.round(ahorro * 100 / v.compare_at_price) + '%'
            : formatearDinero(ahorro, formatoMoneda);
          $('[data-etiqueta-ahorro-texto]', etiqueta).textContent = (bloque.dataset.textoAhorro || '').replace('[ahorro]', txt);
        }
      }
    }

    function actualizarBoton(v) {
      var boton = $('[data-boton-compra]', seccion);
      if (!boton) return;
      var texto = $('[data-boton-compra-texto]', boton);
      boton.disabled = !v || !v.available;
      if (texto) texto.textContent = v && v.available ? texto.dataset.textoDisponible : texto.dataset.textoAgotado;
    }

    function alCambiarOpcion() {
      var elegidas = opcionesElegidas();
      $$('[data-opcion-elegida]', seccion).forEach(function (el) {
        el.textContent = elegidas[Number(el.dataset.opcionElegida)] || '';
      });
      var v = variantes.find(function (vv) {
        return vv.options.every(function (o, i) { return o === elegidas[i]; });
      });
      if (!v) { actualizarBoton(null); return; }
      if (inputId) {
        inputId.value = v.id;
        inputId.dispatchEvent(new Event('change', { bubbles: true }));
      }
      actualizarPrecio(v);
      actualizarBoton(v);
      actualizarPacks(v);
      if (v.featured_media && galeria && galeria.irAMedia) galeria.irAMedia(v.featured_media.id);
      if (!seccion.hasAttribute('data-sin-url') && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      document.dispatchEvent(new CustomEvent('ip:variante-cambiada', { detail: { variante: v } }));
    }
    $$('[data-opcion]', seccion).forEach(function (el) { el.addEventListener('change', alCambiarOpcion); });

    /* Cantidad */
    $$('[data-cantidad]', seccion).forEach(function (caja) {
      var input = $('input', caja);
      $('[data-cantidad-menos]', caja).addEventListener('click', function () { input.value = Math.max(1, (Number(input.value) || 1) - 1); });
      $('[data-cantidad-mas]', caja).addEventListener('click', function () { input.value = (Number(input.value) || 1) + 1; });
    });

    /* Packs por cantidad */
    var packs = $('[data-packs]', seccion);
    function actualizarPacks(v) {
      if (!packs || !v) return;
      var ref = Math.max(v.compare_at_price || 0, v.price);
      $$('input[type="radio"]', packs).forEach(function (r) {
        var cant = Number(r.value) || 1;
        var desc = Number(r.dataset.descuento) || 0;
        var total = Math.round(v.price * cant * (100 - desc) / 100);
        var antes = ref * cant;
        var caja = r.nextElementSibling;
        var t = $('[data-pack-total]', caja); if (t) t.textContent = formatearDinero(total, formatoMoneda);
        var a = $('[data-pack-antes]', caja);
        if (a) { a.hidden = !(antes > total); a.textContent = formatearDinero(antes, formatoMoneda); }
      });
    }
    if (packs) {
      var ocultoCant = $('[data-packs-cantidad]', packs);
      var cajaCantidad = $('[data-cantidad] input', seccion);
      if (cajaCantidad && ocultoCant) ocultoCant.disabled = true;
      packs.addEventListener('change', function (e) {
        if (e.target.type !== 'radio') return;
        if (ocultoCant) ocultoCant.value = e.target.value;
        if (cajaCantidad) cajaCantidad.value = e.target.value;
        document.dispatchEvent(new CustomEvent('ip:pack-cambiado', { detail: { cantidad: Number(e.target.value) } }));
      });
    }

    /* Evitar doble envío del formulario */
    var form = $('[data-producto-form]', seccion);
    if (form) form.addEventListener('submit', function () {
      var b = $('[data-boton-compra]', seccion);
      if (b) setTimeout(function () { b.disabled = true; }, 0);
    });

    /* Barra fija de compra */
    var barra = $('[data-barra-fija]', seccion);
    var zonas = $$('[data-zona-compra]', seccion);
    if (barra && zonas.length) {
      barra.hidden = false;
      var pendiente = false;
      function revisarBarra() {
        pendiente = false;
        var alto = window.innerHeight;
        zonas = $$('[data-zona-compra]', seccion);
        var activas = zonas.filter(function (z) { return z.offsetParent !== null && z.offsetHeight > 0; });
        if (!activas.length) activas = zonas;
        var algunaVisible = activas.some(function (z) {
          var r = z.getBoundingClientRect();
          return r.bottom > 0 && r.top < alto;
        });
        var pasada = activas[0].getBoundingClientRect().bottom < 0;
        barra.classList.toggle('ip-visible', !algunaVisible && pasada);
        document.body.classList.toggle('ip-barra-activa', !algunaVisible && pasada);
      }
      window.addEventListener('scroll', function () {
        if (!pendiente) { pendiente = true; window.requestAnimationFrame(revisarBarra); }
      }, { passive: true });
      window.addEventListener('resize', revisarBarra);
      revisarBarra();
      $('[data-ir-a-compra]', barra).addEventListener('click', function () {
        zonas = $$('[data-zona-compra]', seccion);
        var destino = zonas.filter(function (z) { return z.offsetParent !== null && z.offsetHeight > 0; })[0] || zonas[0];
        destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var b = destino.querySelector('#rsi_buy_now_button, button, a');
        if (b) setTimeout(function () { b.focus({ preventScroll: true }); }, 600);
      });
    }

    if (galeria) iniciarGaleria(galeria);
  }

  /* ---------- Barra de anuncios rotativa ---------- */
  function iniciarAnuncios(raiz) {
    if (raiz.dataset.listo) return;
    raiz.dataset.listo = '1';
    var items = $$('[data-anuncio]', raiz);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      if (document.hidden) return;
      items[i].classList.remove('ip-activo');
      i = (i + 1) % items.length;
      items[i].classList.add('ip-activo');
    }, Number(raiz.dataset.velocidad || 4) * 1000);
  }

  /* ---------- Comparar antes / después ---------- */
  function iniciarAntesDespues(raiz) {
    if (raiz.dataset.listo) return;
    raiz.dataset.listo = '1';
    var rango = $('input[type="range"]', raiz);
    if (!rango) return;
    function mover() { raiz.style.setProperty('--ip-posicion', rango.value + '%'); }
    rango.addEventListener('input', mover);
    mover();
  }

  /* ---------- Contadores circulares ---------- */
  function iniciarCirculos(raiz) {
    if (raiz.dataset.listo) return;
    raiz.dataset.listo = '1';
    var circulos = $$('[data-circulo]', raiz);
    function animar(c) {
      var meta = Number(c.dataset.circulo) || 0;
      var num = $('[data-circulo-numero]', c);
      var inicio = null;
      c.classList.add('ip-animado');
      function paso(t) {
        if (!inicio) inicio = t;
        var p = Math.min(1, (t - inicio) / 1200);
        if (num) num.textContent = Math.round(meta * p) + '%';
        if (p < 1) window.requestAnimationFrame(paso);
      }
      window.requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { circulos.forEach(function (c) { c.classList.add('ip-animado'); }); return; }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (en.isIntersecting) { animar(en.target); obs.unobserve(en.target); }
      });
    }, { threshold: 0.4 });
    circulos.forEach(function (c) { obs.observe(c); });
  }

  /* ---------- Animación al aparecer ---------- */
  var obsAparecer = null;
  function iniciarAparecer(root) {
    if (!document.body.classList.contains('ip-con-animaciones')) return;
    var els = $$('.ip-aparecer:not(.ip-visible)', root);
    if (!('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) {
      els.forEach(function (el) { el.classList.add('ip-visible'); });
      return;
    }
    if (!obsAparecer) {
      obsAparecer = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('ip-visible'); obsAparecer.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -60px 0px' });
    }
    els.forEach(function (el) { obsAparecer.observe(el); });
  }

  /* ---------- Videos tipo reels ---------- */
  var obsVideos = null;
  function iniciarVideos(root) {
    var videos = $$('.ip-videos video', root);
    if (!videos.length) return;
    if (!obsVideos && 'IntersectionObserver' in window) {
      obsVideos = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else v.pause();
        });
      }, { threshold: 0.5 });
    }
    videos.forEach(function (v) {
      if (v.dataset.listo) return;
      v.dataset.listo = '1';
      v.muted = true; v.setAttribute('playsinline', '');
      if (obsVideos) obsVideos.observe(v);
      var boton = v.parentElement.querySelector('[data-video-sonido]');
      if (boton) boton.addEventListener('click', function () {
        var activar = v.muted;
        $$('.ip-videos video').forEach(function (otro) {
          otro.muted = true;
          var b = otro.parentElement.querySelector('[data-video-sonido]');
          if (b) { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Activar sonido'); }
        });
        v.muted = !activar;
        boton.setAttribute('aria-pressed', activar ? 'true' : 'false');
        boton.setAttribute('aria-label', activar ? 'Silenciar' : 'Activar sonido');
        if (activar) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      });
    });
  }

  /* ---------- Volver arriba ---------- */
  function iniciarVolverArriba() {
    var b = $('[data-volver-arriba]');
    if (!b) return;
    b.hidden = false;
    b.style.opacity = '0'; b.style.pointerEvents = 'none'; b.style.transition = 'opacity .3s';
    window.addEventListener('scroll', function () {
      var mostrar = window.scrollY > 700;
      b.style.opacity = mostrar ? '1' : '0';
      b.style.pointerEvents = mostrar ? 'auto' : 'none';
    }, { passive: true });
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- Cuenta regresiva ---------- */
  function iniciarCuenta(raiz) {
    if (raiz.dataset.listo) return;
    raiz.dataset.listo = '1';
    var modo = raiz.getAttribute('data-modo');
    var fin;
    if (modo === 'fecha') {
      var txt = (raiz.getAttribute('data-fin') || '').trim().replace(' ', 'T');
      fin = new Date(txt).getTime();
      if (isNaN(fin)) { raiz.setAttribute('data-sin-fecha', ''); return; }
    }
    var horas = parseInt(raiz.getAttribute('data-horas'), 10) || 24;
    function objetivo() {
      if (modo === 'fecha') return fin;
      /* Modo diario: termina a medianoche, o cada X horas desde la medianoche */
      var ahora = new Date();
      var base = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate()).getTime();
      var bloque = horas * 3600000;
      return base + Math.ceil((ahora.getTime() - base + 1) / bloque) * bloque;
    }
    var celdas = {
      d: raiz.querySelector('[data-d]'), h: raiz.querySelector('[data-h]'),
      m: raiz.querySelector('[data-m]'), s: raiz.querySelector('[data-s]')
    };
    function dos(n) { return (n < 10 ? '0' : '') + n; }
    function pintar() {
      var resto = Math.max(0, objetivo() - Date.now());
      var seg = Math.floor(resto / 1000);
      if (celdas.d) celdas.d.textContent = dos(Math.floor(seg / 86400));
      if (celdas.h) celdas.h.textContent = dos(Math.floor(seg % 86400 / 3600));
      if (celdas.m) celdas.m.textContent = dos(Math.floor(seg % 3600 / 60));
      if (celdas.s) celdas.s.textContent = dos(seg % 60);
      if (resto <= 0 && modo === 'fecha') { raiz.setAttribute('data-terminada', ''); clearInterval(timer); }
    }
    pintar();
    var timer = setInterval(pintar, 1000);
  }

  /* ---------- Arranque ---------- */
  function iniciarTodo(root) {
    root = root || document;
    $$('[data-producto]', root).forEach(iniciarProducto);
    $$('[data-galeria]', root).forEach(iniciarGaleria);
    $$('[data-mini-slider]', root).forEach(iniciarMiniSlider);
    $$('[data-anuncios]', root).forEach(iniciarAnuncios);
    $$('[data-antes-despues]', root).forEach(iniciarAntesDespues);
    $$('[data-circulos]', root).forEach(iniciarCirculos);
    $$('[data-cuenta]', root).forEach(iniciarCuenta);
    iniciarVideos(root);
    iniciarAparecer(root);
  }

  window.ImpulsoPro = { iniciar: iniciarTodo, formatearDinero: formatearDinero };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciarTodo(); iniciarVolverArriba(); });
  } else {
    iniciarTodo(); iniciarVolverArriba();
  }

  /* Editor de temas de Shopify: reiniciar al editar secciones */
  document.addEventListener('shopify:section:load', function (e) { iniciarTodo(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-pista] > *');
    if (slide) irA(slide.parentElement, Array.prototype.indexOf.call(slide.parentElement.children, slide));
  });
})();
